import dayjs from 'dayjs';
import utcPlugin from 'dayjs/plugin/utc';

dayjs.extend(utcPlugin);

import 'dayjs/locale/tr';

dayjs.locale('tr');
